// src/pages/Project.jsx
import ComingSoon from '../components/ComingSoon';

const Project = () => {
  return <ComingSoon pageName="Project Management" />;
};
export default Project;